import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint } from '../../../../util/theme';

const PreLoanBody = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0 15px;

  @media (min-width: ${getBreakpoint('md')}) {
    flex-direction: row;

    padding: 0;
  }
`;

export default PreLoanBody;
